import React, { Component } from 'react';
import { connect } from 'react-redux';
import get from 'lodash/get';
import { Tabs, Tab } from 'react-bootstrap';
import { PublisherApi } from '../../../api';
import { ContentHolder } from '../../../components/common';
import BillingForm from '../../../components/publisher/billing/BillingForm';
import Payments from '../../../components/publisher/billing/Payments';

class BillingIndex extends Component {

  state = { key: 1 };

  componentWillMount() {
    this.fetchResource();
  }

  fetchResource(params = {}) {
    const { dispatch, billing } = this.props;
    if (!billing.uuid) {
      dispatch(PublisherApi.actions.billing.get(params));
    }
  }

  handleSelect(key) {
    this.setState({ key });
  }

  render() {
    const { isLoading, billing } = this.props;

    return (
      <div className='ibox'>
        <div className='ibox-title'>
          <h5>Billing</h5>      
        </div>
        <div className='ibox-content'>
          <Tabs 
            activeKey={this.state.key} 
            onSelect={this.handleSelect.bind(this)} 
            id="controlled-tab"
          >
            <Tab eventKey={1} title="Billing Info" className='p-md'>
              <ContentHolder loading={isLoading}>
                <BillingForm billing={billing} />
              </ContentHolder>
            </Tab>
            <Tab eventKey={2} title="Payments" className='p-md'>
              <Payments />
            </Tab>
          </Tabs>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  const { publisher } = state;
  const isLoading = publisher.billing.loading;
  const billing = get(publisher, 'billing.data.data', {});
  
  return { isLoading, billing };
};

export default connect(mapStateToProps)(BillingIndex);
